export default __webpack_public_path__ + "d256a5b510a685030be375c63a9010e9.png";